import { DatePicker } from '@signavio/ui/core';
import { utils } from '../../styles';
import { useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const DatePickerComponent = ({
  style,
  onChange,
  onBlur,
  ...rest
}) => {
  const styles = useStyles(datePickerStyles, {
    style
  });
  return /*#__PURE__*/_jsx("div", {
    ...styles,
    children: /*#__PURE__*/_jsx(DatePicker, {
      ...rest,
      style: styles('picker'),
      enableOutsideDays: true,
      "data-testid": 'datepicker',
      onChange: date => {
        onChange(date);
        if (onBlur) {
          onBlur();
        }
      }
    })
  });
};
const datePickerStyles = ({
  color,
  font,
  lineHeight,
  padding
}) => {
  const dayTotalHeight = utils.calculateHeight(font.size.normal, lineHeight, padding.small);
  return {
    backgroundColor: 'white',
    padding: padding.xsmall,
    picker: {
      outline: 'none',
      caption: {
        paddingTop: padding.xsmall,
        height: lineHeight
      },
      'nav-bar': {
        top: padding.xsmall
      },
      'nav-button': {
        height: lineHeight / 2
      },
      navigation: {
        month: {
          backgroundColor: 'white',
          fontSize: font.size.normal
        },
        year: {
          backgroundColor: 'white',
          fontSize: font.size.normal
        }
      },
      weekdays: {
        ...utils.borderTop(1, 'solid', color.mono.light)
      },
      weekday: {
        color: color.mono.ultradark,
        fontWeight: 'bold',
        height: dayTotalHeight,
        lineHeight: `${lineHeight}px`,
        padding: null,
        fontSize: null
      },
      month: {
        backgroundColor: 'white'
      },
      day: {
        padding: null,
        outline: 'none',
        border: 'none',
        minWidth: dayTotalHeight,
        height: dayTotalHeight,
        lineHeight: `${lineHeight}px`,
        '&today': {
          backgroundColor: color.primary.light,
          color: utils.color(color.primary.light)
        },
        '&selected': {
          backgroundColor: color.primary.base,
          color: utils.color(color.primary.base)
        }
      }
    }
  };
};
export default DatePickerComponent;